import { Avatar, StackItem, Ellipsis, overlayStyle, Stack, Text, theme, Tooltip } from '@prophecy/ui';
import { tokens as AvatarTokens } from '@prophecy/ui/Avatar/tokens';
import { isUndefined } from 'lodash-es';
import styled from 'styled-components';
import { format as timeAgoFormat } from 'timeago.js';

export function shortenCommitHash(value: string) {
  return value.substring(0, 10);
}

export function renderCommitHash(value?: string) {
  return (
    <Tooltip title={value}>
      <Stack width='min-content'>
        <Text level='sm13' tone={theme.colors.gray500}>
          {!isUndefined(value) ? shortenCommitHash(value) : '--'}
        </Text>
      </Stack>
    </Tooltip>
  );
}

export function renderCommitMessage(value: string) {
  return (
    <Text level='sm13' tone={theme.colors.gray500}>
      <Ellipsis
        tooltip={true}
        tooltipProps={{
          overlayStyle
        }}>
        {!isUndefined(value) ? value : '--'}
      </Ellipsis>
    </Text>
  );
}

export function renderColumnWithEllipsis(value: string, _?: unknown, index?: number, isMarkdown: boolean = true) {
  return (
    <Text level='sm13' className='column-cell'>
      <Ellipsis
        tooltip={true}
        tooltipProps={{
          overlayStyle,
          isMarkdown: isMarkdown ? 'title' : undefined
        }}>
        {!isUndefined(value) ? value : ''}
      </Ellipsis>
    </Text>
  );
}

export function renderDescriptionWithEllipsis(_value: string, record: { description?: string }) {
  const value = _value ?? record.description;
  return (
    <Text level='sm13'>
      <Ellipsis
        tooltip={true}
        tooltipProps={{
          overlayStyle
        }}>
        {!isUndefined(value) ? value : ''}
      </Ellipsis>
    </Text>
  );
}

export function renderTimeColumnWithEllipsis(value: number | string, record?: unknown, index?: number, color?: string) {
  return (
    <Text level='sm13' tone={color || theme.colors.gray900}>
      <Ellipsis tooltip={true}>{!isUndefined(value) ? timeAgoFormat(value) : '--'}</Ellipsis>
    </Text>
  );
}

const StyledAvatar = styled(Avatar)`
  &[data-state='closed'] {
    background: ${theme.colors.white};
  }
  &[data-state='delayed-open'] {
    background: ${AvatarTokens.background};
  }
`;

export function renderCommitAuthor(name: string, email: string, hasAuthorName?: boolean) {
  const avatarUi = (
    <Stack width={theme.spaces.x24}>
      <StyledAvatar withBorder={true} size='xs' text={name} />
    </Stack>
  );
  if (hasAuthorName) {
    return (
      <Stack direction='horizontal' gap={theme.spaces.x8} alignY='center'>
        {avatarUi}
        <StackItem grow='1'>
          <Text level='sm13' tone={theme.colors.gray900}>
            <Ellipsis tooltip={true}>{name}</Ellipsis>
          </Text>
        </StackItem>
      </Stack>
    );
  }

  return (
    <Tooltip
      title={
        <Stack gap={theme.spaces.x4}>
          <Text level='xs' tone={theme.colors.white} weight={theme.fontWeight.medium}>
            {name}
          </Text>
          <Text level='xs' tone={theme.colors.gray400} weight={theme.fontWeight.medium}>
            {email}
          </Text>
        </Stack>
      }>
      {avatarUi}
    </Tooltip>
  );
}

export function renderTimeColumnInDaysWithEllipsis(value: number) {
  const currentDay = new Date().getTime();
  const differenceInTime = value - currentDay;
  const days = Math.ceil(differenceInTime / (1000 * 3600 * 24));
  const dateMsg = days === 1 ? 'Today' : days === 2 ? 'Tomorrow' : `In ${days} days`;

  return (
    <Text level='sm13' tone={theme.colors.gray900}>
      <Ellipsis tooltip={true}>{!isUndefined(value) ? dateMsg : '--'}</Ellipsis>
    </Text>
  );
}
